/**
 * `GET /vehicle-catalog` — the make/model catalogue every client keeps an
 * offline copy of (phase VC, plan D-C). Types only: the api validates with
 * its own Zod schema pinned to these (`satisfies z.ZodType<VehicleCatalogDto>`),
 * and the app parses tolerantly — shared carries no runtime dependency.
 *
 * Contract rules:
 * - `schemaVersion` changes only for a BREAKING change (a new route then);
 *   fields are added, never repurposed. A client that sees an unknown
 *   `schemaVersion` keeps what it has.
 * - `version` is the data version, monotonic, bumped by every catalogue
 *   write; the ETag is derived from it.
 * - Order is the server's: makes and models arrive popular → on sale →
 *   regular → legacy, then A–Z. Clients group, they do not re-sort.
 * - Names are display strings as users know them; they are data, not i18n keys.
 * - No ids (AUT-438): entries are identified by name / alias (plan D-A — nothing
 *   stores a catalogue id), and uuids were ~78% of the body and barely compress.
 */
export const VEHICLE_CATALOG_SCHEMA_VERSION = 1;
/** Canonical names never exceed the order DTO's make/model limit. */
export const VEHICLE_CATALOG_NAME_MAX = 50;
//# sourceMappingURL=vehicle-catalog.js.map